import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchPaymentOverview } from "../../api/PaymentAPIs";

const cards = [
  ["totalOnlinePayments", "كل المدفوعات الأونلاين"],
  ["successfulPayments", "ناجحة"],
  ["pendingPayments", "قيد الانتظار"],
  ["failedPayments", "فاشلة"],
  ["refundedPayments", "مستردة"],
];

export default function PaymentsOverviewPage() {
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [status, setStatus] = useState("");
  const params = {
    from: from ? new Date(from).toISOString() : "",
    to: to ? new Date(new Date(to).getTime() + 86400000).toISOString() : "",
    status,
  };
  const { data, isLoading, error } = useQuery({
    queryKey: ["paymentOverview", params],
    queryFn: () => fetchPaymentOverview(params),
  });

  return (
    <div className="space-y-4">
      <div className="bg-white border border-slate-200 rounded-2xl p-4 flex flex-wrap gap-3">
        <input type="date" value={from} onChange={(e) => setFrom(e.target.value)} className="border rounded-lg px-3 py-2" />
        <input type="date" value={to} onChange={(e) => setTo(e.target.value)} className="border rounded-lg px-3 py-2" />
        <select value={status} onChange={(e) => setStatus(e.target.value)} className="border rounded-lg px-3 py-2">
          <option value="">كل الحالات</option>
          <option value="Paid">مدفوع</option>
          <option value="Pending">قيد الانتظار</option>
          <option value="Failed">فشل</option>
          <option value="Refunded">مسترد</option>
          <option value="PartiallyRefunded">مسترد جزئياً</option>
        </select>
      </div>
      {isLoading && <p>جاري التحميل...</p>}
      {error && <p className="text-red-600">{error.message}</p>}
      {data && (
        <>
          <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
            {cards.map(([key, label]) => (
              <div key={key} className="bg-white border border-slate-200 rounded-2xl p-4">
                <p className="text-sm text-slate-500">{label}</p>
                <p className="text-2xl font-bold">{data[key] ?? 0}</p>
              </div>
            ))}
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            <Amount label="إجمالي الناجح" value={data.totalSuccessfulAmount} currency={data.currency} />
            <Amount label="ناجح اليوم" value={data.todaySuccessfulAmount} currency={data.currency} />
            <Amount label="ناجح هذا الشهر" value={data.monthSuccessfulAmount} currency={data.currency} />
          </div>
        </>
      )}
    </div>
  );
}

function Amount({ label, value, currency }) {
  return (
    <div className="bg-white border border-slate-200 rounded-2xl p-4">
      <p className="text-sm text-slate-500">{label}</p>
      <p className="text-2xl font-bold">{Number(value || 0).toLocaleString()} {currency || "EGP"}</p>
    </div>
  );
}
